// import { useState, useCallback } from "react";
// import { toast } from "react-toastify";
// import { updateSubscriptionApi } from "../../apis/subscriptionApi";

// export const useUpdateSubscription = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const updateSubscription = useCallback(async (id, data) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Updating subscription...");

//     try {
//       const updated = await updateSubscriptionApi(id, data);
//       toast.update(toastId, {
//         render: "Subscription updated successfully",
//         type: "success",
//         isLoading: false,
//         autoClose: 2000,
//       });
//       return updated;
//     } catch (err) {
//       const msg = err.message || "Failed to update subscription";
//       setError(msg);
//       toast.update(toastId, {
//         render: msg,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   return { updateSubscription, loading, error };
// };



import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { updateSubscriptionApi } from "../../apis/subscriptionApi";

export const useUpdateSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
   // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to update subscription.",
    };
  };

  const updateSubscription = useCallback(async (id, data) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Updating subscription...");

    try {
      const updated = await updateSubscriptionApi(id, data);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Subscription Updated</strong>
            <div>Subscription updated successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });

      return updated;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { updateSubscription, loading, error };
};